import React, { memo } from 'react'
import { bool, string, oneOf, node, func, style } from 'prop-types'
import classNames from '../../helpers/class-names'

import svgList from './svg-list'

import './_style.scss'

const blk = 'asda-icon'

const Icon = ({
  dataAutoId,
  className,
  size,
  color,
  asBrand,
  name,
  rotate,
  children,
  onClickHandler,
  style,
}) => {
  const eltClass = classNames({
    blk,
    className,
    mods: [color, size, `rotate${rotate}`, asBrand && 'brand'],
  })
  return (
    <span
      role="button"
      tabIndex="0"
      onClick={onClickHandler}
      onKeyPress={event => (event.key === 13 ? onClickHandler() : null)}
      data-auto-id={dataAutoId}
      className={eltClass}
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: svgList[name] || children }}
      style={style}
    />
  )
}

Icon.propTypes = {
  children: node,
  dataAutoId: string,
  size: oneOf(['tiny', 'small', 'medium', 'regular', 'large']),
  color: oneOf(['green', 'red', 'blue', 'yellow', 'charcoal', 'dark-gray', 'gray', 'white']),
  asBrand: bool,
  className: string,
  name: string,
  rotate: oneOf(['0', '90', '180', '270']),
  onClickHandler: func,
  style,
}

Icon.defaultProps = {
  children: null,
  dataAutoId: '',
  size: 'regular',
  asBrand: false,
  className: '',
  name: '',
  rotate: '0',
  color: 'charcoal',
  onClickHandler: () => {},
  style: {},
}

export default memo(Icon)



// WEBPACK FOOTER //
// ./common/components/icon/index.js